import gql from 'graphql-tag';

const query = gql`
  query ClientBranding($tmc: String) {
    clientBranding(tmc: $tmc) {
      clientId
      companyName
      brandColor
      logoUrl
      headerLogoUrl
      bottomLogoUrl
      uiUrl
      tmcName
      tmcStreetAddress
      tmcCityAddress
      tmcCountry
      telNumber
      tmcFacebookLink
      tmcInstaLink
      tmcTwitterLink
      tmcLinkedinLink
    }
  }
`;

export default function clientBranding({ apollo, tmc }) {
  return apollo.query({
    query,
    variables: { tmc }
  });
}
